import { render, staticRenderFns } from "./software.vue?vue&type=template&id=eb448cdc&scoped=true"
import script from "./software.vue?vue&type=script&lang=js"
export * from "./software.vue?vue&type=script&lang=js"
import style0 from "./software.vue?vue&type=style&index=0&id=eb448cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb448cdc",
  null
  
)

export default component.exports